import ActionLink from "components/ActionLink";
import { useAuthContext, useOnline } from "common/hooks";

export default function PageHead({ breadcrumb, createFarmGroup }) {
    const online = useOnline();
    const authContext = useAuthContext();

    return (
        <>
            <section className="PageHead">
                <div className="Container">
                    <div className="FarmTitle">
                        <div className="FarmTitle-heading">
                            <span id="page-head-title" className="FarmTitle-name">
                                {"Portfolio Reporting (" + authContext.accountName + ")"}
                            </span>
                        </div>
                    </div>
                    {online && (
                        <div className="PageHead-actions">
                            {process.env.REACT_APP_DISABLE_FARM_GROUPS !== "true" && (
                                <ActionLink id="myfarms-header-create-group" className="IconLink--arrow-plus" onClick={createFarmGroup}>
                                    Create farm group
                                </ActionLink>
                            )}
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}
